import { GET_CSP, GET_DELIVERY_ZONEID } from "../database/get-stored-data";
import { SET_STORE_DEFAULT_CONFIG } from "../database/store-data";
import { EncryptStorage } from "encrypt-storage";
import { dto_Customer } from "../classes/dto-customer";
import { dto_common } from "../classes/dto-common";
import {
  CODE,
  ENTRY_MODE,
  MID,
  SECRET_KEY,
  STORE_Addons,
  STORE_AUTO_PLACE_BANK_GUID,
  STORE_AUTO_PLACE_ORDER,
  STORE_AUTO_PLACE_PAYMODE,
  STORE_Cart,
  STORE_CartCheckoutData,
  STORE_DineType,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_INVALID_QR,
  STORE_MERCHANT_SCROLL,
  STORE_PAGE_URL,
  STORE_PRODUCT_LIST,
  STORE_PROMO_PRODUCT_LIST,
  STORE_SHEDULEDateNTime,
  STORE_SelectedMerchant,
  STORE_SelectedMerchantProduct,
  TABLE_NO,
} from "../database/store-names";

const $ = require("jquery");

// Runtime config (mutated during startup)
export let CSP = "";
export let currentver = "";
export let BuildVersion = "";
export let Api = "";
export let ApiFallback = "";
export let ApiOuth = "";
export let MainUrl = "";
export let COUNTRY_CODE = "";
export let MAINPAGETITTLE = "";
export let BUILD_TYPE = "PRODUCTION"; // PRODUCTION | STAGING | DEVELOPMENT

// App constants
export const WebWidth = 400;
export const WebLeft = "calc(50% - 200px)";
export const WebTop = 0;
export const WebBottom = 0;
export const WebLoderTop = 0;

const LOCAL_ENCRYPT_STORAGE = new EncryptStorage("PfTxu1vKyVkCqgP", {
  prefix: "@D_A_I_T_O_N_N",
  encAlgorithm: "Rabbit",
});

export const ENCRYPT_STORAGE_SESSION = new EncryptStorage("82a48NnWHOVkuCh", {
  prefix: "@D_A_I_T_O_N_N",
  encAlgorithm: "AES",
  storageType: "sessionStorage",
});

const TAB_SCOPED_STORAGE_KEYS = new Set([
  CODE,
  ENTRY_MODE,
  MID,
  SECRET_KEY,
  STORE_Addons,
  STORE_AUTO_PLACE_BANK_GUID,
  STORE_AUTO_PLACE_ORDER,
  STORE_AUTO_PLACE_PAYMODE,
  STORE_Cart,
  STORE_CartCheckoutData,
  STORE_DineType,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_INVALID_QR,
  STORE_MERCHANT_SCROLL,
  STORE_PAGE_URL,
  STORE_PRODUCT_LIST,
  STORE_PROMO_PRODUCT_LIST,
  STORE_SHEDULEDateNTime,
  STORE_SelectedMerchant,
  STORE_SelectedMerchantProduct,
  TABLE_NO,
  "FROM",
  "GroceryCategory",
  "MasterCategory",
  "MerChantData",
  "SearchStringFilter",
]);

const isTabScopedStorageKey = (key) => TAB_SCOPED_STORAGE_KEYS.has(String(key));

const getStorageEngine = (key) =>
  isTabScopedStorageKey(key) ? ENCRYPT_STORAGE_SESSION : LOCAL_ENCRYPT_STORAGE;

const cloneStoredValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => cloneStoredValue(item));
  }
  if (value && typeof value === "object") {
    return { ...value };
  }
  return value;
};

const getStoredItem = (key) => {
  const normalizedKey = String(key);
  const primaryStorage = getStorageEngine(normalizedKey);
  const primaryValue = primaryStorage.getItem(normalizedKey);

  if (primaryValue !== undefined || !isTabScopedStorageKey(normalizedKey)) {
    return cloneStoredValue(primaryValue);
  }

  const legacyValue = LOCAL_ENCRYPT_STORAGE.getItem(normalizedKey);
  if (legacyValue !== undefined) {
    primaryStorage.setItem(normalizedKey, legacyValue);
  }
  return cloneStoredValue(legacyValue);
};

export const ENCRYPT_STORAGE = {
  clear() {
    ENCRYPT_STORAGE_SESSION.clear();
    TAB_SCOPED_STORAGE_KEYS.forEach((key) => {
      LOCAL_ENCRYPT_STORAGE.removeItem(key);
    });
  },
  getItem(key) {
    return getStoredItem(key);
  },
  getMultipleItems(keys = []) {
    return Object.fromEntries(
      keys.map((key) => [key, getStoredItem(key)]),
    );
  },
  removeItem(key) {
    const normalizedKey = String(key);
    getStorageEngine(normalizedKey).removeItem(normalizedKey);
    if (isTabScopedStorageKey(normalizedKey)) {
      LOCAL_ENCRYPT_STORAGE.removeItem(normalizedKey);
    }
  },
  removeMultipleItems(keys = []) {
    keys.forEach((key) => {
      this.removeItem(key);
    });
  },
  setItem(key, value) {
    const normalizedKey = String(key);
    getStorageEngine(normalizedKey).setItem(normalizedKey, value);
    if (isTabScopedStorageKey(normalizedKey)) {
      LOCAL_ENCRYPT_STORAGE.removeItem(normalizedKey);
    }
  },
};

export let PRIMARY_API_BASE = "";
export let PRIMARY_API_QUERY = "";
export let API_MODE = "LIVE";

const AV_RUNTIME_API_CONFIGS = {
  LIVE: {
    primaryApiWithQuery:
      "https://avasfood.daitonncloud.com/api/comserviceapi/AzureApi",
    secondaryUrl:
      "https://avascustomerapinew-f9d7egeqdhcrfzd6.southeastasia-01.azurewebsites.net/",
  },
};

const CSP_CONFIGS = {
  AV: {
    hardReleaseFallback: "10.0.28",
    buildVersion: "10.0.0.125",
    countryCode: "MV",
    pageTitle: "AVAS FOOD",
    defaultBindings: {
      CSP: "AV",
      NatvieCountry: "MV",
      defaultImageUrl: require("./images/AVASCommon.jpg"),
      ZoneId: 1490,
      DeliveryZoneID: 0,
      MTYPE: "RS",
      ZoneDescription: "Male",
    },
    apiConfigs: {
      LIVE: {
        primaryApiWithQuery:
          "https://avasfood.daitonncloud.com/api/comserviceapi/AzureApi",
        secondaryUrl:
          "https://avascustomerapinew-f9d7egeqdhcrfzd6.southeastasia-01.azurewebsites.net/",
      },
    },
  },
  MK: {
    hardReleaseFallback: "10.2.24",
    buildVersion: "10.0.0.133",
    countryCode: "LK",
    pageTitle: "MKB",
    defaultBindings: {
      CSP: "MK",
      NatvieCountry: "LK",
      defaultImageUrl: require("./images/dummyimage.jpg"),
      ZoneId: 0,
      DeliveryZoneID: 0,
      MTYPE: "GR",
      ZoneDescription: "",
    },
    apiConfigs: {
      LIVE: {
        primaryApiWithQuery:
          "https://avascustomerapinew-f9d7egeqdhcrfzd6.southeastasia-01.azurewebsites.net/api/comserviceapi",
        secondaryUrl:
          "https://mkb-a6adakegcth5d6cd.southeastasia-01.azurewebsites.net/",
      },
      TEST: {
        primaryApiWithQuery:
          "https://test-foodapp-api.daitonncloud.com/api/comserviceapi/AzureApi",
        secondaryUrl: "https://test-foodapp-api.daitonncloud.com/",
      },
      LOCAL: {
        primaryApiWithQuery:
          "https://localhost:44317/api/comserviceapi/AzureApi/",
        secondaryUrl: "https://localhost:44317/",
      },
    },
  },
  DT: {
    hardReleaseFallback: "10.0.23",
    buildVersion: "10.0.0.133",
    countryCode: "LK",
    pageTitle: "DAITONN",
    defaultBindings: {
      CSP: "DT",
      NatvieCountry: "LK",
      defaultImageUrl: require("./images/dummyimage.jpg"),
      ZoneId: 0,
      DeliveryZoneID: 0,
      MTYPE: "RS",
      ZoneDescription: "",
    },
    apiConfigs: {
      LIVE: {
        primaryApiWithQuery:
          "https://LiveFoodAppSL.daitonncloud.com/api/comserviceapi/AzureApi/",
        secondaryUrl: "https://test-foodapp-api.daitonncloud.com/",
      },
      TEST: {
        primaryApiWithQuery:
          "https://LiveFoodAppSL.daitonncloud.com/api/comserviceapi/AzureApi/",
        secondaryUrl: "https://test-foodapp-api.daitonncloud.com/",
      },
      LOCAL: {
        primaryApiWithQuery:
          "https://localhost:44317/api/comserviceapi/AzureApi/",
        secondaryUrl: "https://localhost:44317/",
      },
    },
  },
};

const normalizeVersion = (version) => {
  if (version === undefined || version === null) return undefined;
  const normalized = String(version).trim();
  if (normalized === "" || normalized === "undefined") return undefined;
  return normalized;
};

const resolveCurrentVersion = (incomingVersion, fallbackVersion) =>
  normalizeVersion(incomingVersion) ||
  normalizeVersion(currentver) ||
  fallbackVersion;

const normalizeType = (value) => {
  const normalized = String(value || "LIVE").trim().toUpperCase();
  if (normalized === "LOCAL") return "LOCAL";
  if (normalized === "TEST") return "TEST";
  return "LIVE";
};

export const RESOLVE_ENVIRONMENT_FROM_API_MODE = (apiMode) =>
  apiMode === "LIVE" ? "LIVE" : "TEST";

export const GET_API_MODE = () => normalizeType(API_MODE);

let iconifyConfigCache = null;
let iconifyConfigRequested = false;

const loadIconifyConfig = async () => {
  if (iconifyConfigRequested) {
    return iconifyConfigCache;
  }
  iconifyConfigRequested = true;
  try {
    const response = await fetch("/iconify.json", { cache: "no-store" });
    if (!response.ok) {
      return null;
    }
    const json = await response.json();
    iconifyConfigCache = json;
    return iconifyConfigCache;
  } catch (error) {
    return null;
  }
};

const resolveCspRuntimeOverrides = async (cspParam) => {
  const selectedConfig = CSP_CONFIGS[cspParam];
  if (cspParam === "AV") {
    API_MODE = "LIVE";
    return {
      ...AV_RUNTIME_API_CONFIGS.LIVE,
      resolvedApiMode: "LIVE",
    };
  }

  const iconifyConfig = await loadIconifyConfig();
  const resolvedApiMode = normalizeType(iconifyConfig?.API_MODE || API_MODE);

  API_MODE = resolvedApiMode;

  if (!iconifyConfig || typeof iconifyConfig !== "object") {
    if (selectedConfig?.apiConfigs?.[resolvedApiMode]) {
      return {
        ...selectedConfig.apiConfigs[resolvedApiMode],
        resolvedApiMode,
      };
    }
    return null;
  }

  const cspConfigs = iconifyConfig.cspConfigs;
  if (!cspConfigs || typeof cspConfigs !== "object") {
    return null;
  }
  const cspConfig = cspConfigs[cspParam];
  if (!cspConfig || typeof cspConfig !== "object") {
    return null;
  }
  const typeKey = `${cspParam}-${resolvedApiMode}`;
  const override = cspConfig[typeKey];
  if (!override || typeof override !== "object") {
    if (selectedConfig?.apiConfigs?.[resolvedApiMode]) {
      return {
        ...selectedConfig.apiConfigs[resolvedApiMode],
        resolvedApiMode,
      };
    }
    throw new Error(
      `Missing API config in public/iconify.json for key ${typeKey}.`,
    );
  }
  return {
    ...override,
    resolvedApiMode,
  };
};

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const ensureApiConfig = (cspParam, config) => {
  const primaryApiWithQuery = String(config?.primaryApiWithQuery || "").trim();
  const secondaryUrl = String(config?.secondaryUrl || "").trim();

  if (!primaryApiWithQuery || !secondaryUrl) {
    throw new Error(
      `Missing API config in public/iconify.json for CSP ${cspParam}.`,
    );
  }

  return {
    primaryApiWithQuery,
    secondaryUrl: trimTrailingSlash(secondaryUrl),
  };
};

const resolveFallbackApi = (secondaryUrl, primaryApiWithQuery) => {
  const normalizedMainUrl = trimTrailingSlash(secondaryUrl);
  const [primaryApiBase] = String(primaryApiWithQuery || "").split("?");
  const normalizedPrimaryApiBase = trimTrailingSlash(primaryApiBase);

  if (normalizedMainUrl.toLowerCase().includes("/api/comserviceapi")) {
    return normalizedMainUrl;
  }

  try {
    const primaryUrl = new URL(normalizedPrimaryApiBase);
    const secondaryBaseUrl = new URL(`${normalizedMainUrl}/`);
    const primaryApiPath = trimTrailingSlash(primaryUrl.pathname);

    if (primaryApiPath) {
      return trimTrailingSlash(
        `${secondaryBaseUrl.origin}${primaryApiPath.startsWith("/") ? "" : "/"}${primaryApiPath}`,
      );
    }
  } catch (_error) {
    // Fall through to the site root if URL parsing fails.
  }

  return `${normalizedMainUrl}/`;
};

const setApiEndpoints = ({ primaryApiWithQuery, fallbackApi }) => {
  const [primaryApiBase, primaryApiQuery = ""] = (
    primaryApiWithQuery || ""
  ).split("?");
  PRIMARY_API_BASE = trimTrailingSlash(primaryApiBase);
  PRIMARY_API_QUERY = primaryApiQuery;
  Api = PRIMARY_API_BASE;
  ApiFallback = trimTrailingSlash(fallbackApi);
};

export const SET_STARTUP = async ({ csp, HardReleaseVersion }) => {
  if (csp === undefined) return;

  const cspParam = String(csp).toUpperCase();
  const selectedConfig = CSP_CONFIGS[cspParam];
  if (!selectedConfig) return;
  const runtimeOverride = await resolveCspRuntimeOverrides(cspParam);
  const apiConfig = ensureApiConfig(cspParam, runtimeOverride);
  const effectiveConfig = {
    ...selectedConfig,
    ...apiConfig,
    ...(runtimeOverride || {}),
  };

  CSP = cspParam;
  currentver = resolveCurrentVersion(
    HardReleaseVersion,
    effectiveConfig.hardReleaseFallback,
  );
  BuildVersion = effectiveConfig.buildVersion;

  MainUrl = apiConfig.secondaryUrl;
  const fallbackApi =
    effectiveConfig.fallbackApi ||
    resolveFallbackApi(
      apiConfig.secondaryUrl,
      apiConfig.primaryApiWithQuery,
    );
  setApiEndpoints({
    primaryApiWithQuery: apiConfig.primaryApiWithQuery,
    fallbackApi,
  });
  ApiOuth = effectiveConfig.apiOuth || `${MainUrl}/api/outh/login`;

  COUNTRY_CODE = effectiveConfig.countryCode;
  MAINPAGETITTLE = effectiveConfig.pageTitle;

  await SET_DEFAULT_BINDINGS(effectiveConfig.defaultBindings);
};

async function SET_DEFAULT_BINDINGS(defaultBindings) {
  let {
    CSP: localCSP,
    NatvieCountry,
    defaultImageUrl,
    ZoneId,
    ZoneDescription,
    DeliveryZoneID,
    MTYPE,
  } = defaultBindings;

  const storedCsp = await GET_CSP();
  if (storedCsp !== undefined) {
    localCSP = storedCsp;
  }

  const storedDeliveryZoneId = await GET_DELIVERY_ZONEID();
  if (storedDeliveryZoneId !== undefined) {
    DeliveryZoneID = storedDeliveryZoneId;
  }

  dto_common.CSP = localCSP;
  dto_common.NatvieCountry = NatvieCountry;
  dto_common.DefaultImageUrl = defaultImageUrl;
  dto_common.CurrentCordinate = "0,0";
  dto_common.PicupCordinate = "0,0";
  dto_Customer.CSID = 0;
  dto_Customer.NIC = 0;
  dto_common.DineType = 4;
  dto_common.ZoneId = ZoneId;
  dto_common.ZoneDescription = ZoneDescription;
  dto_common.DeliveryZoneID = DeliveryZoneID;
  dto_common.MTYPE = MTYPE;
  dto_common.HeaderTabName = "";

  await SET_STORE_DEFAULT_CONFIG(
    ZoneId,
    ZoneDescription,
    DeliveryZoneID,
    MTYPE,
  );
}

export const SET_ZONE_DESCRIPTION_HOME_SCREEN = (Description) => {
  const zoneHomeScreen = document.getElementById("ZoneHomeScreen");
  if (zoneHomeScreen) {
    $("#ZoneHomeScreen").html(Description + "     - OUTLETS");
  }
};
